import { __read, __assign } from 'tslib';
import { jsx, Fragment } from '@emotion/react/jsx-runtime';
import { createContext } from '../../utils/createContext.js';
import { useDropdownContext } from '../../Dropdown/DropdownProvider.js';
import { renderProp } from '../../utils/renderProp.js';

var _a = __read(createContext({
    name: "Menu",
}), 2), useMenuContext = _a[0], MenuContext = _a[1];
var MenuProvider = MenuContext.Provider;
var useMenuDropdownContext = function () {
    return __assign(__assign({}, useMenuContext()), useDropdownContext());
};
var MenuRenderProp = function (_a) {
    var children = _a.children;
    var context = useMenuDropdownContext();
    return jsx(Fragment, { children: renderProp({ prop: children, context: context }) });
};

export { MenuContext, MenuProvider, MenuRenderProp, useMenuContext, useMenuDropdownContext };
//# sourceMappingURL=MenuProvider.js.map
